export const CHECK_USER_IS_AUTHORIZED_REQUEST = 'CHECK_USER_IS_AUTHORISED_REQUEST';
export const CHECK_USER_IS_AUTHORIZED_SUCCEED = 'CHECK_USER_IS_AUTHORISED_SUCCEED';
export const CHECK_USER_IS_AUTHORIZED_FAILURE = 'CHECK_USER_IS_AUTHORISED_FAILED';

export const ALERT_MODAL_DISPLAY_STATUS = 'ALERT_MODAL_DISPLAY_STATUS';



// WEBPACK FOOTER //
// ./app/components/with-auth/action-types.js